/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * format of the certificate signing request (PEM or DER)
 */
export enum CsrFormat {
    PEM = 'PEM',
    DER = 'DER',
}